import { render, staticRenderFns } from "./app-carousel.vue?vue&type=template&id=37182803&"
import script from "./app-carousel.vue?vue&type=script&lang=js&"
export * from "./app-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports